import { Avatar, Clickable, Col, Row, Text } from 'components';
import { closeNotifs, theme } from 'lib';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const Image = styled.img`
  width: 48px;
  height: 64px;
  object-fit: cover;
`;

const ClickableBold = ({ onClick, children }) => (
  <Clickable onClick={onClick}>
    <Text bold>{children}</Text>
  </Clickable>
);

const CommentTagged = ({ data }) => {
  const { sender, timestamp, entityId, subEntityId } = data,
    navigate = useNavigate(),
    dispatch = useDispatch(),
    { t } = useTranslation();

  return (
    <Clickable
      onClick={() => {
        closeNotifs();
        navigate(`/post/${entityId}`);
      }}
    >
      <Row noFlex pad="0 0 16px" center>
        <Avatar small avatar={sender.avatar} user={sender} />

        <Col marg="0 0 0 16px">
          <Row between useStart>
            <Trans
              parent={Text}
              components={{
                strong: <Text bold />
              }}
            >
              {t('notifications.commentTagged', { sender: sender.name || sender.username })}
            </Trans>

            <Text b2 med col={theme.GREY_60}>
              {timestamp}
            </Text>
          </Row>
        </Col>
      </Row>
    </Clickable>
  );
};

export default CommentTagged;
